import { useMutation } from '@tanstack/react-query';

import { addInvestbox } from '../../../../../../api';
import { AggregateInvestbox } from '../../../../../../types/aggregateInvestbox';

export const useAddInvestBox = () =>
  useMutation({ mutationKey: ['addInvestbox'], mutationFn: (data: Partial<AggregateInvestbox>) => addInvestbox(data) });
